module.exports = __webpack_public_path__ + "static/media/Resources.c0107d7f.svg";